import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { VehicleSelector } from "@/components/VehicleSelector";
import { Manifesto } from "@/components/Manifesto";
import { Stages } from "@/components/Stages";
import { Testimonials } from "@/components/Testimonials";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";
import { BookingModal } from "@/components/BookingModal";
import { WhatsAppFloat, FacebookFloat } from "@/components/WhatsAppFloat";
import { PromoBanner } from "@/components/PromoBanner";
import Admin from "@/pages/Admin";

export const LOGO_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_23858cfc-8b83-47db-9d0a-145d36bd9f74/artifacts/5kflcxfc_Automotive%20solutions%20in%20motion%20black.png";

const Landing = () => {
  const [booking, setBooking] = useState({ open: false, vehicle: null, stage: null });

  const openBooking = useCallback((opts = {}) => {
    setBooking({ open: true, vehicle: opts.vehicle || null, stage: opts.stage || null, promo: opts.promo || null });
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-asphalt text-neutral-100 min-h-screen font-body antialiased overflow-x-hidden">
      <div className="grain-overlay" />
      <Header onBook={() => openBooking()} />
      <PromoBanner onClaim={() => openBooking({ promo: "BM50" })} />
      <main>
        <Hero onBook={() => openBooking()} />
        <Marquee />
        <VehicleSelector onBook={(vehicle) => openBooking({ vehicle })} />
        <Manifesto />
        <Stages onBook={(stage) => openBooking({ stage })} />
        <Testimonials />
        <Faq />
      </main>
      <Footer />
      <BookingModal
        state={booking}
        onOpenChange={(o) => setBooking((s) => ({ ...s, open: o }))}
      />
      <WhatsAppFloat />
      <FacebookFloat />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <Toaster theme="dark" position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
